/* eslint-disable no-duplicate-case */
import { useEffect } from "react";
import { useHistory, useLocation, } from "react-router-dom";
// import axios from "axios";
import { tokenDecode } from "../../utils/helper";
// import allorderslist from "../../pages/allorderslist";

const ProtectedRoute = ({ children }: any) => {
    const history = useHistory();
    const location = useLocation();
    const search = useLocation().search;
    const tk_access = new URLSearchParams(search).get('tk_access');

    // const token: any = sessionStorage.getItem("us_st_d");
    // const TokenChecker = async () => {
    //     try {
    //         const { data } = await axios({
    //             url: "/login/refresh",
    //             method: "POST",
    //             headers: {
    //                 "x-custom-authorization": `Bearer ${token}`
    //             }
    //         });
    //         sessionStorage.setItem("isLogedIn", data.refreshToken);
    //     } catch (error) {
    //         sessionStorage.removeItem("isLogedIn");
    //     }
    // }
    useEffect(() => {
        //   TokenChecker();
    }, []);
    const keyV = location.pathname.split("/")[1];
    try {
        const decoded: any = tokenDecode(tk_access);
        const { data } = decoded;
        const { permission: { category, order, product, role, seller, tax, user, location, igm, transaction } } = data;
        // console.log("hhhh", decoded);

        if (decoded) {
            // if (isAdmin === "true") {
            //     return children;
            // }
            switch (keyV) {
                case "":
                    return children;
                case "dashboard":
                    return children;
                case "addseller":
                    return seller.write ? children : history.push("/")
                case "sellerlist":
                    return seller.read ? children : history.push("/");
                case "tax":
                    return tax.write ? children : history.push("/");
                case "updateseller":
                    return seller.update ? children : history.push("/");
                case "roles":
                    return role.write ? children : history.push("/")
                case "adduser":
                    return user.write ? children : history.push("/");
                case "updateuser":
                    return user.update ? children : history.push("/");
                case "userlist":
                    return user.read ? children : history.push("/");
                case "category":
                    return category.write ? children : history.push("/");
                case "product":
                    return product.write ? children : history.push("/");
                case "productlist":
                    return product.read ? children : history.push("/");
                case "orderlist":
                    return order.read ? children : history.push("/");
                case "orderdetails":
                    return order.read ? children : history.push("/");
                case "transaction":
                    return transaction.read ? children : history.push("/");
                case "payments":
                    return transaction.read ? children : history.push(("/"));
                case "location":
                    return location.read ? children : history.push("/");
                case "returnorders":
                    return order.read ? children : history.push("/");
                case "issues":
                    return igm.read ? children : history.push("/");
                case "onissues":
                    return igm.read ? children : history.push(("/"));
                case "grievancesettings":
                    return igm.read ? children : history.push(("/"));
                case "ondclistedproduct":
                    return product.read ? children : history.push(("/"));
                case "approved-enums":
                    return product.read ? children : history.push(("/"));
                case "credentials-list":
                    return product.read ? children : history.push(("/"));
                case "producttypelist":
                    return category.read ? children : history.push(("/"));
                case "producttype":
                    return category.read ? children : history.push(("/"));
                case "updatepricestructure":
                    return product.read ? children : history.push(("/"));

                case "mastercatalog":
                    return children;
                case "buyerfee":
                    return children;
                case "logrejection":
                    return children;
                case "masterproductlist":
                    return children;
                case "ondcsellerproduct":
                    return children;
                case "ondcsellerproductadd":
                    return children;
                case "nonapprovedproducts":
                    return children;
                case "nonapprovedproducts":
                    return children;
                case "nonapprovedproduct":

                    return children;
                case "serviceability":
                    return children;
                case "notifications":
                    return children;
                case "sellernonapprovedproducts":
                    return children;
                case "test":
                    return children;

                case "profile":
                    return children;
                case "sellerdetail":
                    return children;
                case "logs":
                    return children;
                case "sidebar":
                    return children;
                case "ondcsellerapp":
                    return children;
                case "resetpassword":
                    return children;
                case "selleregister":
                    return children;
                case "personaldetails":
                    return children;
                case "bankdetails":
                    return children;
                case "checkseller":
                    return children;
                case "pending":
                    return children;

                case "catalog":
                    return product.read ? children : history.push("/");
                case "productcatalog":
                    return product.read ? children : history.push("/");
                case "instorecatalog":
                    return product.read ? children : history.push("/");
                case "createproduct":
                    return product.read ? children : history.push("/");
                case "order":
                    return order.read ? children : history.push("/");

                case "allorderslist":
                    return children;
                case "orderCompleteDetail":
                    return order.read ? children : history.push("/");
                case "orderCompleteinfo":
                    return order.read ? children : history.push("/");
                case "customerorder":
                    return order.read ? children : history.push("/");
                case "completeOrder":
                    return order.read ? children : history.push("/");
                case "cancelOrderlist":
                    return order.read ? children : history.push("/");
                case "unsettledtransactions":
                    return transaction.read ? children : history.push("/");
                case "brand":
                    return children;
                case "sellerauthcheck":
                    return children;
                case "newcategory":
                    return children;
                case "seeorderdetails":
                    return children;
                case "acceptedorderdetail":
                    return children;
                case "orderpopup":
                    return children;
                case "updatestoreproduct":
                    return children;
                case "invoice":
                    return children;
                case "order_invoice":
                    return children;
                case "supportlist":
                    return children;
                case "rspdashboard":
                    return children;
                case "updatepassword":
                    return children;
                case "settings":
                    return children;
                case "socialtagging":
                    return children;
                case "loglist":
                    return children;
                case "ondcsaleschannel":
                    return children;
                case "raiseissue":
                    return children;
                case "issueslists":
                    return children;
                default:
                    return history.push("/");
            }

        } else {
            console.log("no");
            switch (keyV) {
                case "forget-password":
                    return children;
                case "reset-password":
                    return children;
                default:
                    return history.push("/");
            }
        }
    } catch (error) {
        console.log("this erro -->", error);

        switch (keyV) {
            case "forget-password":
                return children;
            case "reset-password":
                return children;
            case "test":
                return children;
            default:
                return history.push("/");
        }
    }
}


export default ProtectedRoute;
